export const ENTITY_KEY_PARAM = 'entityKey';

const BASE64_KEY_CHAR_CLASS = '[A-Za-z0-9+/]';
export const BASE64_KEY_TOKEN_BODY_PATTERN = `(?:(?:${BASE64_KEY_CHAR_CLASS}{4})){3,}(?:${BASE64_KEY_CHAR_CLASS}{2}==|${BASE64_KEY_CHAR_CLASS}{3}=|${BASE64_KEY_CHAR_CLASS}{4})`;
const BASE64_KEY_TOKEN_EXACT = new RegExp(`^${BASE64_KEY_TOKEN_BODY_PATTERN}$`);

export function isValidBase64KeyToken(token: string): boolean {
  return !!token && BASE64_KEY_TOKEN_EXACT.test(token);
}
